<div class="pdf-native-wrapper">
    <div class="pdf-loading" *ngIf="isLoading">
        <div class="pdf-spinner"></div>
        <span>{{ 'common.PDF_VIEWER.LOADING' | translate }}</span>
    </div>

    <div class="pdf-error" *ngIf="error">
        ⚠️ {{ error | translate }}
    </div>

    <div class="pdf-clean-container" #canvasContainer *ngIf="!isLoading && !error"></div>
</div>